module.exports = __webpack_public_path__ + "img/kelian.4d2933c0.gif";